import PropTypes from 'prop-types';

import styles from './PayersLayout.module.scss';

const PayersLayout = ({ children }) => (
  <section className={styles.payersLayout}>{children}</section>
);

PayersLayout.propTypes = {
  children: PropTypes.node,
};

PayersLayout.defaultProps = {
  children: <div />,
};

export default PayersLayout;
